/** Max distance from the sit teleport point to treat a remote as seated. */
export const SIT_CLIP_RADIUS = 20;

export function audienceSitY(seat, renderHeight) {
  return seat.y + Math.round(renderHeight * 0.5);
}

function withinSitRadius(dx, dy, radius = SIT_CLIP_RADIUS) {
  return dx * dx + dy * dy < radius * radius;
}

/**
 * World-Y clip line for a remote sprite, or null if they are standing.
 * Local players clip only while seated; remotes used to clip whenever they
 * stood in the aisle within 50–70px of a sit point.
 */
export function remoteSeatClipY(player, mapData, { teamSitY, renderHeight }) {
  if (!player || player.moveState === 'walk' || player.moveState === 'run') {
    return null;
  }
  const x = player.x;
  const y = player.y;
  if (mapData?.teamSeats) {
    for (const ts of mapData.teamSeats) {
      if (withinSitRadius(x - ts.cx, y - teamSitY)) {
        return ts.y + ts.height;
      }
    }
  }
  if (mapData?.seats) {
    for (const as of mapData.seats) {
      const sitY = audienceSitY(as, renderHeight);
      if (withinSitRadius(x - as.cx, y - sitY)) {
        return as.y;
      }
    }
  }
  return null;
}
